/* eslint-disable  */
import React from 'react';
import { useState } from 'react';
import { Button, Grid, TextField } from '@material-ui/core';


const TitlesForm = props => {


    const styles = {
        root: { 
            margin: '10px'
        }
    };


    const { initialValues, setModalOpen, onSubmit } = props;


    const [title, setTitle] = useState(initialValues?.name)
    const [description, setDescription] = useState(initialValues?.description)
    const [enabled, setEnabled] = useState(false)


    const validateForm = () => {
        if (title ) {
            setEnabled(true)
        }
    }

     // handles to change the state of the form fields once are clicked.
        const handleSubmit = async event => {
            // console.log(title)
            // console.log('eeeee')
            setModalOpen(false)
            event.preventDefault();
            onSubmit && onSubmit({
                ...initialValues,
                title,
                description
            })
        }

        const handleChangeTitle = (e) => {
            console.log(e.target.value)
            setTitle(e.target.value)
            validateForm()
        }

        const handleChangeDescription = (e) => {
            setDescription(e.target.value)
            validateForm()
        }

        

    return (


        <form onSubmit={handleSubmit} style={styles.root}>
            <Grid container spacing={3} justifyContent='flex-end'>
                <TextField
                    name='title_name'
                    value={title || ''}
                    label='Job Title Name'
                    fullWidth
                    onChange={handleChangeTitle}
                > 
                </TextField>
                <TextField
                    name='title_description'
                    value={description || ''}
                    label='Job Title Description'
                    fullWidth
                    onChange={handleChangeDescription}
                > 
                </TextField>
            </Grid>


            <Grid container justifyContent='flex-end' spacing={3} style={{ marginTop: '10px' }}>
                <Grid item>
                    <Button
                        onClick={() => {
                            setModalOpen(false)
                        }}
                            children='Cancel'
                            variant='contained'
                            />
                </Grid>
                <Grid item>
                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        disabled={!enabled}
                        onClick={ handleSubmit}
                        children='Submit'
                    />
                </Grid>
            </Grid>
        </form>
    );
};


const validate = values => {

    const errors = {};

    if (!values.name) {
        errors.name = 'You must enter a Name';
    }

    return errors;

};

export default TitlesForm;
